module.exports = __webpack_public_path__ + "static/media/chat.f3056f18.svg";